import DesUpdateLibraryViewModel from 'viewmodel/DesUpdateLibraryViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesUpdateLibrary extends DesBaseCatalogAcc {
    constructor() {
        super(DesUpdateLibraryViewModel);
    }

    get libraryId() {
        return this.getAttribute('library-id') || this.getAttribute('libraryid');
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    getProps() {
        return {
            libraryid: this.libraryId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'locale',
            'library-id', 'libraryid'];
    }
}

if (!window.customElements.get('des-update-library')) {
    window.customElements.define('des-update-library', DesUpdateLibrary);
}
